import type { StoryObj } from '@storybook/web-components';
import { userEvent, waitFor, within } from '@storybook/testing-library';

export const BasicExample = args => `
<style>
content-navigation-block[aria-expanded="true"] .content-navigation__content-wrapper {
  background: black;
}
content-navigation-block[aria-expanded="true"] a,
content-navigation-block[aria-expanded="true"] svg {
  color: white;
}
</style>
<content-navigation-block>
  <button slot="openButton" aria-label="Toggle Navigation">
    =
  </button>
  <nav slot="content">
    <ul>
      <li><content-button href="/">About</content-button></li>
      <li><content-button href="/">Membership</content-button></li>
      <li><content-button href="/">Events</content-button></li>
      <li><content-button href="/">Media</content-button></li>
      <li><content-button href="/">Advocacy</content-button></li>
      <li><content-button href="/">Cyber</content-button></li>
      <li><content-button href="/">Podcasts</content-button></li>
    </ul>
</nav>
</content-navigation-block>`;

BasicExample.args = {
  // src: 'https://picsum.photos/id/2/768/400',
};

export default {
  title: 'Content Navigation Block',
};
